const FIELD_NAME_OVERRIDES: Record<string, string> = {
	ip: 'IP',
	functionalityNameSnapshot: 'Parameter name'
}

export const EXCLUDED_FIELDS = ['functionalityId']

export const formatFieldName = (key: string): string => {
	if (FIELD_NAME_OVERRIDES[key]) return FIELD_NAME_OVERRIDES[key]
	return key
		.replace(/([A-Z])/g, ' $1')
		.replace(/^\w/, c => c.toUpperCase())
		.trim()

}

export const formatValue = (val: unknown): string => {
	if (val === true) return 'Yes'
	if (val === false) return 'No'
	if (Array.isArray(val)) return val.join(', ') || '—'
	return String(val ?? '-')
}
